import type {
  OrganizationPreferenceRequestBody,
  OrganizationPreferenceResponseBody,
} from '@rtkwlf/notification-service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useNotificationPreferencesApi } from '../use-notification-preferences-api';

import { getNotificationPreferencesQueryKey } from './use-get-notification-preferences';

export const useUpsertNotificationPreferences = () => {
  const queryClient = useQueryClient();
  const preferencesApi = useNotificationPreferencesApi();
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  return useMutation({
    mutationFn: (params: { input: OrganizationPreferenceRequestBody }) => {
      const updates: OrganizationPreferenceRequestBody = {
        isEmailEnabled: params.input.isEmailEnabled,
        isDigestEnabled: params.input.isDigestEnabled,
        isITSMEnabled: params.input.isITSMEnabled,
        subjectPrefix: params.input.subjectPrefix,
        subjectSuffixes: params.input.subjectSuffixes,
      };
      return preferencesApi.upsertOrganizationPreference({
        organizationUUID: organizationId,
        organizationPreferenceRequestBody: updates,
      }) as unknown as Promise<OrganizationPreferenceResponseBody>;
    },
    onSuccess: (data: OrganizationPreferenceResponseBody) => {
      // Update the query cache directly with the returned data
      queryClient.setQueryData(
        getNotificationPreferencesQueryKey(organizationId),
        data,
      );
    },
  });
};
